import React, { useState, useEffect, useCallback } from "react";
import {
  BiCheck,
  BiCopyright,
  BiHash,
  BiRecycle,
  BiTrashAlt,
} from "react-icons/bi";
import { BsFillBookmarksFill, BsGearFill } from "react-icons/bs";
import { BsThreeDotsVertical } from "react-icons/bs";
import { v4 as uuidv4 } from "uuid";
import {
  Row,
  Col,
  Button,
  Popover,
  PopoverBody,
  ButtonGroup,
  Label,
  Dropdown,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from "reactstrap";
import { connect } from "react-redux";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import * as actionCreators from "../../../modules/actions/index";
import Loading from "../../../hoc/Loading/Loading";
import { toastContainer } from "../../../utils/toast";
import parse from "react-html-parser";
import "./WaitingResponsesMobile.css";
import "./menu-modals-bwai.css";

function ApplyPurchaseToTrivvy({
  open,
  onClose,
  trivia,
  user,
  handleUpdateRow,
  orgChangeSuccess
}) {
  const orgObject = user.profile.organizationId;

  const [inputValue, setInputValue] = useState(0);

  const applyPurchase = () => {
    axios.post(url.applyPurchaseToTrivvy, {
      triviaId:trivia._id,
      responseAmountToApply: inputValue,
    }).then(({data})=>{
      const result = data.data;
      handleUpdateRow(result.triviaUpdate)
      orgChangeSuccess(result.orgUpdate)
      onClose()
    }).catch(err=>{
      toastContainer("Cant apply purchase","error")
    })
  };

  const isValidApplicablePurchase = ()=>{
    const trivvyWaiting = trivia.waitingCount;
    const totalvalid =   orgObject.totalTriviaResponsesCount -
    orgObject.submittedTriviaResponsesCount;

    if(totalvalid < inputValue){
      return false
    }
    if(trivvyWaiting < inputValue){
      return false
    }

    return true
  }

  let applicablePurchases =
    orgObject.totalTriviaResponsesCount -
    orgObject.submittedTriviaResponsesCount;

  if(trivia.waitingCount <= applicablePurchases){
    applicablePurchases = trivia.waitingCount
  }
  return (
    <Modal
      isOpen={open}
      className="apply-purchase-modal bwai-modal bwai_menu_modal bwai_apply_purchase"
    >
      <ModalHeader className="bwai_modal_header" toggle={onClose}>Apply Purchase</ModalHeader>
      <ModalBody>
      <div className="my-2 bwai_ap_row">
          Trivia: {trivia.name}
        </div>
        <div className="my-2 bwai_ap_row">
          Waiting Count: {trivia.waitingCount}
        </div>
        <div className="m-4 bwai_ap_field">
          <Input
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            type={"number"}
            min={0}
            className="w-150 bwai_ap_input"
          />
        </div>
        {!isValidApplicablePurchase() ? (
          <small className="text-danger bwai_ap_error">
            You have maximum {applicablePurchases} purchase limit left & max waiting limit of {trivia.waitingCount} so you cant apply purchases greater than this amount.
          </small>
        ) : (
          ""
        )}
      </ModalBody>
      <ModalFooter className="bwai_ap_footer">
        <Button
          disabled={!isValidApplicablePurchase()}
          className="trivia-action-button-main fill"
          onClick={applyPurchase}
        >
          Apply Purchase
        </Button>

        <Button  size="sm" className="ml-2 trivia-action-button-main-secondary mr-4" onClick={()=> onClose() }>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(ApplyPurchaseToTrivvy, axios));
